import { render, staticRenderFns } from "./DragDetail.vue?vue&type=template&id=7997e8d8&scoped=true&"
import script from "./DragDetail.vue?vue&type=script&lang=js&"
export * from "./DragDetail.vue?vue&type=script&lang=js&"
import style0 from "./DragDetail.vue?vue&type=style&index=0&id=7997e8d8&lang=scss&scoped=true&"
import style1 from "./DragDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7997e8d8",
  null
  
)

export default component.exports